import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Divider,
} from '@chakra-ui/react';
import Footer from '../components/layout/footer';

const TermsAndConditions = () => {
  return (
    <Container maxW="container.md" py={10} flexDirection={"column"}>
      <VStack spacing={6} align="start">
        <Heading as="h1" size="xl">
          Terms and Conditions
        </Heading>

        <Text fontSize="md" color="gray.600">
          Welcome to Sale Radius CRM! These Terms and Conditions (“Terms”) govern your use of our platform and services. By signing up, you agree to comply with these Terms.
        </Text>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            1. Acceptance of Terms
          </Heading>
          <Text mb={4}>
            By accessing or using our services, you agree to be bound by these Terms. If you do not agree, please do not use our platform.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            2. Account Responsibility
          </Heading>
          <Text mb={4}>
            You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            3. Use of Service
          </Heading>
          <Text mb={4}>
            You agree to use the platform only for lawful purposes and in a way that does not infringe the rights of others or restrict their use of the services.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            4. Subscription and Payment
          </Heading>
          <Text mb={4}>
            Access to certain features may require a paid subscription. You agree to provide accurate payment information and pay all fees associated with your subscription on time.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            5. Data Privacy and Security
          </Heading>
          <Text mb={4}>
            We are committed to protecting your data in accordance with our Privacy Policy. You agree to comply with all applicable data protection laws.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            6. Intellectual Property
          </Heading>
          <Text mb={4}>
            All content, features, and functionality are the exclusive property of Sale Radius CRM and are protected by intellectual property laws.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            7. Termination
          </Heading>
          <Text mb={4}>
            We may suspend or terminate your account if you violate these Terms or for any other reason at our discretion.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            8. Disclaimer of Warranties
          </Heading>
          <Text mb={4}>
            The platform is provided “as is” without warranties of any kind. We do not guarantee the accuracy or availability of the service.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            9. Limitation of Liability
          </Heading>
          <Text mb={4}>
            We are not liable for any indirect, incidental, or consequential damages arising from your use of the platform.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            10. Changes to Terms
          </Heading>
          <Text mb={4}>
            We reserve the right to update these Terms at any time. Continued use of the platform constitutes acceptance of the revised Terms.
          </Text>

          <Heading as="h2" size="lg" mb={3}>
            11. Governing Law
          </Heading>
          <Text mb={4}>
            These Terms are governed by the laws of Zimbabwe.
          </Text>

          <Divider my={6} />

          <Text>
            By signing up, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
          </Text>
        </Box>
      </VStack>
      <Footer />
    </Container>
  );
};

export default TermsAndConditions;
